import * as fontSizes from 'autogen/design-tokens/global/font';
import type { StrippedFontSizeUnionAsNumbers } from '../types';

export const getFontSizeByNumber = (size: StrippedFontSizeUnionAsNumbers) => fontSizes[`FontSize${size}`];
export const getFontSizeNumbers = () =>
    Object.keys(fontSizes)
        .map((key) => Number.parseInt(key.replace('FontSize', ''), 10))
        .sort((a, b) => a - b);
